import {notify} from './controls/Notifications';
export default notify;



/** WEBPACK FOOTER **
 ** core/client/rawr/notify.js
 **/